/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Faq_Payments_AInputs */

const en_platform_faq_payments_a = /** @type {(inputs: Platform_Faq_Payments_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You sell entry packs - blocks of prepaid sessions - and the app takes one off the pack each time a client turns up, telling you when somebody has run out. You collect the money however you already do.`)
};

const pl_platform_faq_payments_a = /** @type {(inputs: Platform_Faq_Payments_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprzedajesz karnety, czyli pakiety opłaconych z góry wejść, a aplikacja odejmuje jedno za każdym razem, gdy podopieczny przychodzi, i mówi Ci, komu się skończyły. Pieniądze pobierasz tak, jak robisz to dziś.`)
};

/**
* | output |
* | --- |
* | "You sell entry packs - blocks of prepaid sessions - and the app takes one off the pack each time a client turns up, telling you when somebody has run out. Yo..." |
*
* @param {Platform_Faq_Payments_AInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_faq_payments_a = /** @type {((inputs?: Platform_Faq_Payments_AInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Faq_Payments_AInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_faq_payments_a(inputs)
	return en_platform_faq_payments_a(inputs)
});